export default "__VITE_ASSET__DxlVZXeG__"